// extracted by mini-css-extract-plugin
export default {"ContactItem":"ContactItem_ContactItem__-tP80"};